import { createSlice } from '@reduxjs/toolkit';

export const cartItemCount = createSlice({
  name: 'cartItemCount',
  initialState: {
    data: 0,
  },

  reducers: {
    setCartItemCount: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setCartItemCount } = cartItemCount.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getCartItemCount = (state) => state.cartItemCount.data;

export default cartItemCount.reducer;
